"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setProfile = exports.removeFilter = exports.createFilter = void 0;
function createFilter(client, opts) {
    return client.post('create_filter', {
        filter: opts.filter
    });
}
exports.createFilter = createFilter;
function removeFilter(client, opts) {
    return client.post('remove_filter', { uid: opts.uid });
}
exports.removeFilter = removeFilter;
function setProfile(client, opts) {
    return client.post('set_profile', {
        profile: opts.profile
    });
}
exports.setProfile = setProfile;
